module.exports = __webpack_public_path__ + "img/symbol_deletegreen.76bc95b3.png";